<div class='h-100 d-flex  flex-column' id="deviceInfoDiv">

  <div class="right_section_header" id="deviceInfoSection">
    <img class="header_icon" alt="device details" />
    <span i18n="@@device-info.title">Device Info</span>
  </div>
  <div class="right_section_body device_info_tab" id="deviceInfoTab">
    <form [formGroup]='deviceInfoForm' class='gridContainer'>
      <div class="mr-2" id="deviceNameLabel">
        <label class="label-deviceinfo" for="deviceName">{{deviceNameLabel}}</label>
        <input class="form-control" id='deviceName' type="text" formControlName='deviceName' />
      </div>
      <div class="mr-2" id="skuLabel">
        <label class="label-deviceinfo" for="skuId">{{skuIdLabel}}</label>
        <input class="form-control" id='skuId' type="text" formControlName='skuID' />
      </div>
      <figure>
        <img class="img-fluid" alt="battery life in IPOS" />
        <figcaption class="figure-caption">
          <span i18n="@@device-info.example-desc"><strong>Example:</strong> The device battery life is displayed as an
            optional fact tag.</span>
        </figcaption>
      </figure>
      <div class="mr-2" id="batteryLifeDiv">
        <label class="label-deviceinfo" for="batteryLife"><span i18n="@@device-info.batteryLife">Battery Life</span></label>
        <input class="form-control" min='1' type="number" id='batteryLife' formControlName='batteryLife' />
      </div>
      <div id="deviceInfoHours">
        <label for="" class="col-form-label labelHr"><span i18n="@@device-info.hours-label">Hours</span></label>
      </div>
    </form>
    <hr />
    <div class="info_table" id="deviceInfoBrandTbl">
      <div id="infoBrand">
        <legend><span i18n="@@device-info.brand">Brand</span></legend>
        <div>{{brand}}</div>
      </div>
      <div id="infoConnectivity">
        <legend><span i18n="@@device-info.connectivity">Connectivity</span></legend>
        <div class="d-flex" id="infoConnectivityFlex">
          <em *ngIf="connectivityStatus == '2+ Weeks disconnected'" class="dev_inactive_icon"></em>
          <em *ngIf="connectivityStatus == 'Connected'" class="dev_connected_icon"></em>
          <em *ngIf="connectivityStatus == 'Disconnected'" class="dev_disconnected_icon"></em>
          <div id="connectivityStatusMain">
            <div id="infoConnectivityStatus">{{spell(connectivityStatus)}}</div>
            <div id="inforConnectivityText" class="last_time_connected">{{connectivityStatusText}}</div>
          </div>
        </div>
      </div>
      <div id="infoDeviceType">
        <legend><span i18n="@@device-info.device-type">Device Type</span></legend>
        <div id="infoDeviceTypeDisplay">{{ convertText.convertValueToText(deviceType)}}</div>
      </div>
      <div id="operatingSystemDiv">
        <legend><span i18n="@@device-info.operating-system">Operating System</span></legend>
        <div id="infoOperatingDevice">{{operatingSystem}}</div>
      </div>
      <div id="infoProcessorMain">
        <legend><span i18n="@@device-info.processor">Processor</span></legend>
        <div id="infoProcessorDisplay">{{processor}}</div>
      </div>
    </div>
  </div>
  <!-- CTA Buttons -->
  <div class="button_wrapper justify-content-end" id="ctaBtns">
    <button type="button" class="btn btn-outline-primary btn-lg" (click)='cancel()' data-dismiss="modal" [disabled]="!deviceInfoForm.dirty">
      {{cancelLabel}}
    </button>
    <button [disabled]="!deviceInfoForm.dirty" (click)='sendDataToStore()' type="button"
      class="btn btn-primary btn-lg gtmEditDeviceSaveDeviceInfo">
      {{saveChangesLabel}}
    </button>
  </div>
</div>
<!-- remove-popup-message -->
<div class="container" id="containerDiv">
  <div class="modal-dialog-centered" *ngIf="openModalPopup" id="modalDialog">
    <div class="modal-backdrop show" id="modalBackdrop"></div>
    <div class="modal" id="myModal">
      <div class="modal-dialog" id="myModalDialog">
        <div class="modal-content" id="myModalContent">
          <div _ngcontent-fjy-c198="" class="close" (click)="closeModal()"><img _ngcontent-fjy-c198="" alt="close"
              class="modal-close-icon" id="closeModal"></div>
          <div class="modal-body" id="modalBody">
            <div *ngIf='!isCancel' class="action_on_pending_user" id="actionOnPendingUser">
              <span class="success_img"></span>
            </div>
            <div class="action-success-msg" id="actionSuccessMsg">
              <span>{{successMessage}}</span>
            </div>
            <div class="card_desc" id="cardDesc">
              <span>{{description}}</span>
            </div>
          </div>
          <div *ngIf='isCancel' class='modal-footer' id="modalFooter">
            <button class='btn btn-outline-primary btn-lg' (click)="closeModal()">{{buttonLabelNo}}</button>
            <button class='btn btn-primary btn-lg' (click)='dismiss()'>{{buttonLabelCancel}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>